import { useEffect, useState } from "react"
import { useScreenSize } from "@lib/hooks"

import Helmet from "@helpers/Helmet"
import { Course } from "@interfaces/course"
import { AllClassColumn, ClassRow, HomeBanner } from "./components"
import { Header } from "@components/header"
import { HariseninFooter } from "@components/harisenin"
import { DynamicHelmet } from "@interfaces/misc"
import CourseListServices from "@services/course-list.services"
// import { useAnalytics } from "@lib/context/AnalyticsContext"

export interface HomePageProps {
  meta: DynamicHelmet | null
}

export const HomePage = ({ meta }: HomePageProps) => {
  const [isLoadingFavorite, setIsLoadingFavorite] = useState(true)
  const [isLoadingNewest, setIsLoadingNewest] = useState(true)

  const [favoriteList, setFavoriteList] = useState<Course[]>([])
  const [newestList, setNewestList] = useState<Course[]>([])

  const { screenWidth } = useScreenSize()
  const classList = new CourseListServices()
  // const { analytics } = useAnalytics()

  useEffect(() => {
    const getFavoriteCourse = async () => {
      try {
        const favorite = await classList.getCourseList({ limit: 6, page: 1, tag: "popular" })
        if (favorite.isSuccess) {
          setFavoriteList(favorite.getValue().data)
          setIsLoadingFavorite(false)
        } else {
          setIsLoadingFavorite(false)
        }
      } catch (e) {
        setIsLoadingFavorite(false)
      }
    }

    const getNewCourse = async () => {
      try {
        const favorite = await classList.getCourseList({ limit: 6, page: 1, key: "new" })
        if (favorite.isSuccess) {
          setNewestList(favorite.getValue().data)
          setIsLoadingNewest(false)
        } else {
          setIsLoadingNewest(false)
        }
      } catch (e) {
        setIsLoadingNewest(false)
      }
    }

    getFavoriteCourse()
    getNewCourse()
  }, [])

  // useEffect(() => {
  //   analytics.track("Product List Viewed", {
  //     products: [
  //       {
  //         product_id: "",
  //         name: "",
  //         affiliation: "PT. Karya Kaya Bahagia",
  //         coupon: "",
  //         discount: 0,
  //         currency: "IDR",
  //         brand: "HSL",
  //         category: "Video Course",
  //         variant: "",
  //         price: 0,
  //         quantity: 1,
  //         position: 0,
  //         item_list_name: "",
  //         item_list_id: "",
  //       },
  //     ],
  //     item_list_name: "",
  //     item_list_id: "",
  //   })
  // }, [])

  return (
    <>
      <Helmet title={meta?.title} description={meta?.description} isIndexed />
      <Header />

      <main>
        <h1 className="hidden">Kelas terbaru</h1>
        <HomeBanner screenWidth={screenWidth} />
        <ClassRow
          title="Kelas Favorit Yang Wajib Kamu Ikuti"
          screenWidth={screenWidth}
          isLoading={isLoadingFavorite}
          data={favoriteList}
        />

        <ClassRow
          title="Kelas Terbaru"
          screenWidth={screenWidth}
          isLoading={isLoadingNewest}
          data={newestList}
        />

        <AllClassColumn />
      </main>

      <HariseninFooter />
    </>
  )
}

export default HomePage
